
export const APP_DEFAULT_PAGE_SIZE = 10;
export const CONTEXT_MENU_WIDTH = "250px";

export const APP_GLOBAL_HEIGHT = '100vh';

export const APP_MAIN_PADDING = '5px 5px 40px 5px';

export const TREE_ITEM_HEIGHT = '30px';

export const TREE_ITEM_WIDTH = '30px';

export const APP_SUBHEADER_HEIGHT = '60px';

export const SUBSUB_HEADER_HEIGHT = '50px';





